import { Separator } from '@radix-ui/react-dropdown-menu'
import { cn } from '@seen/ui'
import {
  type ComponentPropsWithoutRef,
  type ElementRef,
  forwardRef,
  type ReactNode,
} from 'react'

type SeparatorProps = ComponentPropsWithoutRef<typeof Separator>

export interface DropdownMenuSeparatorProps extends SeparatorProps {
  asChild?: boolean // default fals
  className?: string
  children: ReactNode
}

export const DropdownMenuSeparator = forwardRef<
  ElementRef<typeof Separator>,
  ComponentPropsWithoutRef<typeof Separator>
>(({ className, ...props }, ref) => (
  <Separator
    ref={ref}
    className={cn('-mx-1 my-1 h-px bg-muted', className)}
    {...props}
  />
))
DropdownMenuSeparator.displayName = Separator.displayName
